
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AddressBlock.html?raw';
import countryData from './CountryData.json?raw';
import docu from './AddressBlockDocumentation.html?raw';
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import "../../../moreCore/UI/HintBox/HintBox";
import _StatefulBase from '../../../moreCore/UI/_StatefulBase/_StatefulBase';


//import DataItems = require("DataItems");


class AR_AddressBlock extends compose(_LabelInputBase) {
    templateString: any = template;


    thoroughfare_container: HTMLElement;
    postalCode_container: HTMLElement;
    settlement_container: HTMLElement;
    details_container: HTMLElement;
    addressInformation_container: HTMLElement;
    state_container: HTMLElement;
    district_container: HTMLElement;
    region_container: HTMLElement;
    province_container: HTMLElement;
    department_container: HTMLElement;
    building_container: HTMLElement;
    doubleDependentLocality_container: HTMLElement;
    dependentLocality_container: HTMLElement;
    territory_container: HTMLElement;
    parish_container: HTMLElement;
    chomeName_container: HTMLElement;
    kuName_container: HTMLElement;
    rayon_container: HTMLElement;
    oblast_container: HTMLElement;
    island_container: HTMLElement;
    township_container: HTMLElement;
    suburb_container: HTMLElement;
    destinationSettlement_container: HTMLElement;
    postalAddressCode_container: HTMLElement;
    emirate_container: HTMLElement;
    SelectBox_Country: HTMLElement;

    country: MdsLax<InstanceType<typeof SelectBox>>;
    thoroughfare: MdsLax<InstanceType<typeof Edit>>;
    postalCode: MdsLax<InstanceType<typeof HintBox>>;
    settlement: MdsLax<InstanceType<typeof HintBox>>;
    details: MdsLax<InstanceType<typeof Edit>>;
    addressInformation: MdsLax<InstanceType<typeof Edit>>;
    state: MdsLax<InstanceType<typeof Edit>>;
    district: MdsLax<InstanceType<typeof Edit>>;
    region: MdsLax<InstanceType<typeof Edit>>;
    province: MdsLax<InstanceType<typeof Edit>>;
    department: MdsLax<InstanceType<typeof Edit>>;
    building: MdsLax<InstanceType<typeof Edit>>;
    doubleDependentLocality: MdsLax<InstanceType<typeof Edit>>;
    dependentLocality: MdsLax<InstanceType<typeof Edit>>;
    territory: MdsLax<InstanceType<typeof Edit>>;
    parish: MdsLax<InstanceType<typeof Edit>>;
    chomeName: MdsLax<InstanceType<typeof Edit>>;
    kuName: MdsLax<InstanceType<typeof Edit>>;
    rayon: MdsLax<InstanceType<typeof Edit>>;
    oblast: MdsLax<InstanceType<typeof Edit>>;
    island: MdsLax<InstanceType<typeof Edit>>;
    township: MdsLax<InstanceType<typeof Edit>>;
    suburb: MdsLax<InstanceType<typeof Edit>>;
    destinationSettlement: MdsLax<InstanceType<typeof Edit>>;
    postalAddressCode: MdsLax<InstanceType<typeof Edit>>;
    emirate: MdsLax<InstanceType<typeof Edit>>;


    _country_label: string = (this as any).translations["AdressBlock__country_label"]; //"Country";
    _building_label: string = (this as any).translations["AdressBlock__building_label"]; // "Building/Floor";
    _thoroughfare_label: string = (this as any).translations["AdressBlock__thoroughfare_label"]; // "Thorouhgfare";
    _suburb_label: string = "Suburb";
    _township_label: string = "Township";
    _chomeName_label: string = "Chome Name";
    _kuName_label: string = "Ku Name";
    _details_label: string = "Details";
    _addressInformation_label: string = (this as any).translations["AdressBlock__addressInformation_label"]; // "Additional Information";
    _doubleDependentLocality_label: string = "Double Dependent Locality";
    _dependentLocality_label: string = "Dependent Locality";
    _destinationSettlement_label: string = (this as any).translations["AdressBlock__destinationSettlement_label"]; // "Destination Settlement";
    _district_label: string = "District";
    _postalCode_label: string = (this as any).translations["AdressBlock__postalCode_label"]; // "Postal Code";
    _settlement_sortingCode_label: string = (this as any).translations["AdressBlock__settlement_sortingCode_label"]; // "Setllement and sorting code";
    _settlement_NoSortingCode_label: string = (this as any).translations["AdressBlock__settlement_NoSortingCode_label"]; // "Setllement";
    _state_label: string = (this as any).translations["AdressBlock__state_label"]; // "State";
    _region_label: string = "Region";
    _province_label: string = (this as any).translations["AdressBlock__province_label"]; // "Province";
    _department_label: string = "Department";
    _territory_label: string = "Territory";
    _parish_label: string = "Parish";
    _rayon_label: string = "Rayon";
    _oblast_label: string = "Oblast";
    _island_label: string = (this as any).translations["AdressBlock__island_label"]; // "Island";
    _postalAddressCode_label: string = (this as any).translations["AdressBlock__postalAddressCode_label"]; // "Postal Address Code";
    _emirate_label: string = "Emirate";

    protected _settlement_label_static: string = "Setllement";

    AllCountriesData: Array<object> = JSON.parse(countryData);
    protected topCountries: Array<object> = [];

    // falls man sie irgendwann braucht

    //EU_Countries: string[] = ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
    //    "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
    //    "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
    //    "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"];

    preferredCountries: string[] = ["de", "at", "be", "ch", "es", "fr", "it", "lu", "nl", "gb"]; 

    addressFieldsToShow: Array<string> ;

    allFieldsTotal: Array<string> = ["thoroughfare", "postalCode", "settlement", "details", "addressInformation", "sortingCode", "state", "district", "region", "province", "department", "building", "doubleDependentLocality",
        "dependentLocality", "territory", "parish", "chomeName", "kuName", "rayon", "oblast", "island", "township", "suburb", "destinationSettlement", "postalAddressCode", "emirate"];

    // Props ------------------------------------------------------------START

    mandatoryFields: Array<string> = ["thoroughfare", "postalCode", "settlement", "rayon", "oblast", "island", "destinationSettlement", "postalAddressCode", "emirate"];

    _value: object = {};

    zipCity_controllerUrl: string = "";


    //"ArtistRegistration/GetPostalCodeList"

    // Props ------------------------------------------------------------END

    setZipCity_controllerUrl(url:string): void {
        this.zipCity_controllerUrl = url;
        this.startup();
    }

    _setZipCity_controllerUrlAttr(url: string):void {
        this.setZipCity_controllerUrl(url);
    }

    // Events -------------------------------------------------------START

    _onChange_Country(): void {

        this.addressFieldsToShow = [];

        let selectedCountry = this.country.getValue();

        for (let obj of this.AllCountriesData) {
            if (obj["iso2"] == selectedCountry) {
                for (let addressField of obj["addressSettings"]["fields"]) {
                    this.addressFieldsToShow.push(addressField);
                }
            }
        }

        this.postalCode.addAdditionalRequestParameter('country', this.country.getValue());
        this.settlement.addAdditionalRequestParameter('country', this.country.getValue());

        this.displayRightFields();

        this.addValue(this.country);
    }

    _onChange_building(): void {
        this.addValue(this.building);
        this.emit("valueChange");
    }
    _onChange_thoroughfare(): void {
        this.addValue(this.thoroughfare);
        this.emit("valueChange");
    }
    _onChange_suburb(): void {
        this.addValue(this.suburb);
        this.emit("valueChange");
    }
    _onChange_township(): void {
        this.addValue(this.township);
        this.emit("valueChange");
    }
    _onChange_chomeName(): void {
        this.addValue(this.chomeName);
        this.emit("valueChange");
    }
    _onChange_kuName(): void {
        this.addValue(this.kuName);
        this.emit("valueChange");
    }
    _onChange_details(): void {
        this.addValue(this.details);
        this.emit("valueChange");
    }
    _onChange_addressInformation(): void {
        this.addValue(this.addressInformation);
        this.emit("valueChange");
    }
    _onChange_doubleDependentLocality(): void {
        this.addValue(this.doubleDependentLocality);
        this.emit("valueChange");
    }
    _onChange_dependentLocality(): void {
        this.addValue(this.dependentLocality);
        this.emit("valueChange");
    }
    _onChange_destinationSettlement(): void {
        this.addValue(this.destinationSettlement);
        this.emit("valueChange");
    }
    _onChange_district(): void {
        this.addValue(this.district);
        this.emit("valueChange");
    }
    _onChange_postalCode(): void {
        this.addValue(this.postalCode);

        let zipEntity = this.postalCode.getValue();
        if (zipEntity != null && typeof (zipEntity) == "object") {
            this.settlement.setValue(zipEntity);
        }

        this.emit("valueChange");
    }
    _onChange_settlement(): void {
        this.addValue(this.settlement);
        

        let zipEntity = this.settlement.getValue();
        if (zipEntity != null && typeof (zipEntity) == "object") {
            this.postalCode.setValue(zipEntity);
        } 

        this.emit("valueChange");
    }
    _onChange_state(): void {
        this.addValue(this.state);
        this.emit("valueChange");
    }
    _onChange_region(): void {
        this.addValue(this.region);
        this.emit("valueChange");
    }
    _onChange_province(): void {
        this.addValue(this.province);
        this.emit("valueChange");
    }
    _onChange_department(): void {
        this.addValue(this.department);
        this.emit("valueChange");
    }
    _onChange_territory(): void {
        this.addValue(this.territory);
        this.emit("valueChange");
    }
    _onChange_parish(): void {
        this.addValue(this.parish);
        this.emit("valueChange");
    }
    _onChange_rayon(): void {
        this.addValue(this.rayon);
        this.emit("valueChange");
    }
    _onChange_oblast(): void {
        this.addValue(this.oblast);
        this.emit("valueChange");
    }
    _onChange_island(): void {
        this.addValue(this.island);
        this.emit("valueChange");
    }
    _onChange_postalAddressCode(): void {
        this.addValue(this.postalAddressCode);
        this.emit("valueChange");
    }
    _onChange_emirate(): void {
        this.addValue(this.emirate);
        this.emit("valueChange");
    }

    // Events -------------------------------------------------------END
    // ------------------------------------------------------------------------------------------------------------- TO BE CONTINUED HERE -> test this if you dare
    setMandatoryFields(mandatoryFields: Array<string>): void {
        this.mandatoryFields = mandatoryFields;
    }

    validateInput(): boolean {

        if (this.validationEnabled) {

            this.isValid = this.dataCompletnessCheck();
            
            if (!this.isValid) {
                return false;
            } else {
                return true;
            }

        } else {
            this.isValid = true;
            this._setValidationResultStyle();
            return true;
        }
    }

    dataCompletnessCheck(): boolean {

        let result = true;
        let mandatoryKeys = []

        for (let key of this.allFieldsTotal) {
            if (key == "sortingCode") { continue; }
            if (this[key].isMandatory === true) {
                mandatoryKeys.push(key);
            }
        }

        for (let i = 0; i < mandatoryKeys.length; i++) {

            //(this[mandatoryKeys[i]] as _StatefulBase).validateInput();
            let inp: MdsLax<InstanceType<typeof _StatefulBase>> = this[mandatoryKeys[i]];
            inp.validateInput();

            //this[mandatoryKeys[i]].validateInput()

            if (!this._value.hasOwnProperty(mandatoryKeys[i])) {
                result = false;
            }
        }

        return result;
    }

    displayRightFields(): void {

        for (let field of this.allFieldsTotal) {

            if (this.addressFieldsToShow.indexOf(field) != -1) {
                if (field == "sortingCode") {
                    this.settlement.setLabel(this._settlement_sortingCode_label); 
                    continue;
                } else {
                    this.settlement.setLabel(this._settlement_NoSortingCode_label); 
                }
                this.showinput(this[field]);
            } else {
                if (field != "sortingCode") {
                    this.hideInput(this[field]);
                } 
            }
        }
    }

    hideInput(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        this.UiModder.domClass.add(input.domNode, "w3-hide");
        input.setMandatory(false);
    }

    showinput(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        this.UiModder.domClass.remove(input.domNode, "w3-hide");
        this.mandatoryFields

        for (let field in this.mandatoryFields) {
            if (field == this.getAttachPointNameForWidget(input) && input.validationEnabled === true) {
                input.setMandatory(true);
            }
        }

    }

    populateCountrySelect(node: MdsLax<InstanceType<typeof SelectBox>>): void {

        for (let iso2 of this.preferredCountries) {
            for (let country of this.AllCountriesData) {
                if (country["iso2"]==iso2) {
                    this.topCountries.push(country);
                }
            }
        }



        for (let i = 0; i < this.topCountries.length; i++) {
            let country = this.topCountries[i];
            node.addEntry(country["iso2"], country["name"], true);
        }

        node.addEntry("", "&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473", false);

        for (var i = 0; i < this.AllCountriesData.length; i++) {
            let country = this.AllCountriesData[i];
            node.addEntry(country["iso2"], country["name"], true);
        }

        node.on("valueChange", function (value) { });
        node.setPlaceholder("bitte wählen - please choose");

        let brLanguage = navigator.language.slice(-2).toLowerCase()

        node.setValue(brLanguage, true);

        node.startup();

    }

    // Preferred counries vorne in AllCountriesData platzieren, damit sie im SelectBox oben angezeigt werden
    addPreferredCountries(): void {

        for (let i = 0; i < this.preferredCountries.length; i++) {
            let countryName: string = this.preferredCountries[i];
            for (let i = 0; i < this.AllCountriesData.length; i++) {

                if (this.AllCountriesData[i]["iso2"] == countryName) {
                    this.topCountries.push(this.AllCountriesData[i]);
                }
            }
        }

        //countries.unshift(...topCountries);
    }

    addValue(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        if (input.getValue() && input.validateInput()) {

            this._value[this.getAttachPointNameForWidget(input)] = input.getValue();

        } else {
            delete this._value[this.getAttachPointNameForWidget(input)];
        }
        this.validateInput();
    }

    getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }

    //Doku
    getDocumentationContent(): string {
        return docu;
    }
    //-DOJO----------------------------------------

    _setMandatoryFieldsAttr(fields: Array<string>, bool:boolean): void {
        for (let field of fields) {
            this[field].setMandatory(bool);
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        this.populateCountrySelect(this.country);

        this._onChange_Country();
    }
}

export default mdsWidget(AR_AddressBlock);